export enum RequestCode {
  Success = "Success",
  Failed = "Failed"
}